/**
 * Unit + grouping options and amount formatting for the monthly triangulation.
 * Source values are always in ₹ lakhs; the unit dropdown scales them for display.
 */
export const UNIT_OPTIONS = [
    { key: "lacs", label: "In Lacs" },
    { key: "cr", label: "In Cr" },
    { key: "full", label: "In Full" }
];

export const GROUP_OPTIONS = [
    { key: "month", label: "Monthly" },
    { key: "quarter", label: "Quarterly (FY)" },
    { key: "fy", label: "Financial Year (Apr–Mar)" },
    { key: "year", label: "Calendar Year (Jan–Dec)" }
];

export function unitLabel(unit) {
    const found = UNIT_OPTIONS.find(u => u.key === unit);
    return found ? found.label : "In Lacs";
}

export function unitSuffix(unit) {
    if (unit === "cr") {
        return " Cr";
    }
    if (unit === "full") {
        return "";
    }
    return " L";
}

// Scales a ₹-lakhs value to the chosen unit (numeric).
export function scaleFromLakhs(value, unit) {
    const n = Number(value) || 0;
    if (unit === "cr") {
        return n / 100;
    }
    if (unit === "full") {
        return n * 100000;
    }
    return n;
}

// Formats a ₹-lakhs value for display in the chosen unit (with ₹ + suffix).
export function formatAmount(valueInLakhs, unit) {
    if (
        valueInLakhs === null ||
        valueInLakhs === undefined ||
        valueInLakhs === ""
    ) {
        return null;
    }
    const scaled = scaleFromLakhs(valueInLakhs, unit);
    if (unit === "full") {
        return "₹" + Math.round(scaled).toLocaleString("en-IN");
    }
    const rounded = Math.round(scaled * 100) / 100;
    return (
        "₹" +
        rounded.toLocaleString("en-IN", { maximumFractionDigits: 2 }) +
        unitSuffix(unit)
    );
}
